'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHANNEL = exports.CHANNEL = '__direction__';

var DIRECTIONS = exports.DIRECTIONS = {
  LTR: 'ltr',
  RTL: 'rtl'
};


//////////////////
// WEBPACK FOOTER
// ./~/react-with-direction/dist/constants.js
// module id = 1846
// module chunks = 1